import { useEffect, useRef, useState } from "react";

const Img = ({ src, alt, ...props }) => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const { current } = ref;

    const setDynamicHeight = () => {
      if (current) {
        current.style.height = `${current.offsetWidth * 1.4}px`;
      }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          setDynamicHeight();
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (current) observer.observe(current);

    window.addEventListener("resize", setDynamicHeight);

    return () => {
      if (current) observer.unobserve(current);
      window.removeEventListener("resize", setDynamicHeight);
    };
  }, []);

  return (
    <img
      ref={ref}
      src={isVisible ? src : ""}
      data-src={src}
      alt={alt || "Lazy loaded image"}
      {...props}
    />
  );
};

export default Img;
